import { graphql } from "@opensea/graphql"
import { CreateOrdersSummaryFragment } from "../../../../../components/CreateOrdersSummary/CreateOrdersSummary.fragment"
import { convertItemsAndPricingToListingsFragment } from "../../helpers.fragments"
import { ListingFlowItemsTableFragment } from "../ListingFlowItemsTable/ListingFlowItemsTable.fragment"

export const ListingFlowReview_itemFragment = graphql(
  `
    fragment ListingFlowReview_item on Item {
      id
      name
      tokenId
      imageUrl
      contractAddress
      ...convertItemsAndPricingToListings
      ...ListingFlowItemsTable
      collection {
        chain {
          identifier
          nativeCurrency {
            address
          }
          listingCurrency {
            address
            symbol
          }
        }
        ...CreateOrdersSummary
      }
    }
  `,
  [
    convertItemsAndPricingToListingsFragment,
    ListingFlowItemsTableFragment,
    CreateOrdersSummaryFragment,
  ],
)
